import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const UserMenuDropdown = ({ open, anchorRef, onClose, children }) => {
  const [style, setStyle] = useState(null);

  useEffect(() => {
    if (!open || !anchorRef.current) {
      setStyle(null);
      return undefined;
    }

    const update = () => {
      const rect = anchorRef.current.getBoundingClientRect();
      setStyle({
        top: rect.bottom + 8,
        right: Math.max(16, window.innerWidth - rect.right),
        minWidth: 224
      });
    };

    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update, true);
    };
  }, [open, anchorRef]);

  if (!open || !style) return null;

  return createPortal(
    <>
      <div
        className="fixed inset-0 z-[500] bg-black/20"
        aria-hidden
        onClick={onClose}
      />
      <div
        className="fixed z-[510] rounded-md bg-white shadow-2xl border border-gray-200 py-1.5"
        style={{ top: style.top, right: style.right, minWidth: style.minWidth }}
        role="menu"
      >
        {children}
      </div>
    </>,
    document.body
  );
};

export default UserMenuDropdown;
